// extracted by mini-css-extract-plugin
export default {"buttonHome":"errorPage_buttonHome__4OxXe"};